function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#facebook-black_svg__clip0_372_3678)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.604 0H2.23C1 0 0 1 0 2.23v13.374c0 1.23 1 2.23 2.23 2.23h13.374c1.23 0 2.23-1 2.23-2.23V2.23c0-1.23-1-2.229-2.23-2.229z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.264 8.917h-2.787v-2.23c0-.615.5-.557 1.115-.557h1.114V3.344h-2.229a3.344 3.344 0 00-3.344 3.343v2.23H4.904v2.786h2.23v6.13h3.343v-6.13h1.672l1.115-2.786z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "facebook-black_svg__clip0_372_3678"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h17.833v17.833H0z"
})));

function SvgFacebookBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgFacebookBlack;